import React from 'react'
import PropTypes from 'prop-types'
import Modal from './modal'

const style = {
  content: {
    maxWidth: '860px',
    overflowY: 'scroll',
    height: '80%'
  }
}

const GroupModal = (props) => {
  const { onRequestClose, onClickEdit, children, title } = props
  return (
    <Modal
      style={style}
      isOpen={true}
      onRequestClose={onRequestClose}
      contentLabel="Modal"
    >
      <div className="shop-group-modal">
        {title && <div className="shop-group-modal__title">{title}</div>}
        {onClickEdit && (
          <button className="fa fa-pencil" onClick={onClickEdit} />
        )}
        {children}
      </div>
    </Modal>
  )
}

GroupModal.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  onClickEdit: PropTypes.func,
  onRequestClose: PropTypes.func
}

export default GroupModal
